import React from "react";
import { Flex } from "theme-ui";
import Stars from "./Rating/Stars";
import { ReviewProps } from "./TrustPilot";
const checkMark = (
  <svg
    width="15"
    height="15"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.2188 12.1094C24.2188 18.7972 18.7972 24.2188 12.1094 24.2188C5.42153 24.2188 0 18.7972 0 12.1094C0 5.42153 5.42153 0 12.1094 0C18.7972 0 24.2188 5.42153 24.2188 12.1094ZM10.7087 18.5212L19.6931 9.53682C19.9981 9.23174 19.9981 8.73706 19.6931 8.43198L18.5882 7.32715C18.2832 7.02202 17.7885 7.02202 17.4833 7.32715L10.1562 14.6542L6.7354 11.2333C6.43032 10.9283 5.93564 10.9283 5.63052 11.2333L4.52568 12.3382C4.22061 12.6433 4.22061 13.1379 4.52568 13.443L9.60381 18.5211C9.90894 18.8263 10.4036 18.8263 10.7087 18.5212Z"
      fill="#4F4F4F"
    />
  </svg>
);

function timeSinceReview(reviewDate: any) {
  const timeUnits = ["year", "month", "day", "hour", "minute", "second"];
  const unitMillis = [31536000000, 2592000000, 86400000, 3600000, 60000, 1000];

  const currentDate = new Date();
  const reviewTime = new Date(reviewDate);
  const timeDifference = currentDate - reviewTime;

  for (let i = 0; i < timeUnits.length; i++) {
    const unit = timeUnits[i];
    const unitCount = Math.floor(timeDifference / unitMillis[i]);

    if (unitCount > 0) {
      return `${unitCount} ${unit}${unitCount !== 1 ? "s" : ""} ago`;
    }
  }

  return "Just now";
}

const Review = (props: ReviewProps) => {
  const {
    reviewVerificationLevel,
    id,
    title,
    text,
    stars,
    consumer,
    createdAt,
  } = props;
  return (
    <Flex
      as="a"
      href={`https://www.trustpilot.com/reviews/${id}?utm_medium=trustbox&utm_source=Carousel`}
      sx={{
        minWidth: "240px",
        height: "140px",
        mx: "15px",
        flexDirection: "column",
        // justifyContent: "space-between",
      }}
    >
      <Flex
        sx={{
          alignItems: "center",
        }}
      >
        <Stars rating={stars} size={"18"} />
        {reviewVerificationLevel == "invited" && (
          <Flex
            sx={{
              alignItems: "center",
              mx: "5px",
            }}
          >
            {checkMark}{" "}
            <p sx={{ fontSize: "12px", color: "brand.darkGrey", px: "5px" }}>
              Invited
            </p>
          </Flex>
        )}
      </Flex>
      <p
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          py: "10px",
          height: 35,
          overflow: "hidden",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
        }}
      >
        {title}
      </p>
      <p
        sx={{
          overflow: "hidden",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          fontSize: "13px",
          mb: "10px",
          height: 38,
          WebkitLineClamp: 2,
        }}
      >
        {text}
      </p>
      <p
        sx={{
          fontSize: "12px",
          my: "0px",

          color: "brand.darkGrey",
        }}
      >
        <strong>{consumer.displayName}</strong>, {timeSinceReview(createdAt)}
      </p>
    </Flex>
  );
};

export default Review;
